// Persisted calendar filter preferences — localStorage-first, per user+tenant,
// same convention as useDashboardPreference (navigation/hooks).
const STORAGE_KEY = 'amashr_calendar_filters';

function storageKey(pageKey: string): string {
  const userId = localStorage.getItem('userId') || 'anon';
  const tenant =
    localStorage.getItem('currentWorkspace') ||
    localStorage.getItem('currentTenantSlug') ||
    localStorage.getItem('tenantSlug') ||
    '';
  return `${STORAGE_KEY}_${pageKey}_${userId}${tenant ? `_${tenant}` : ''}`;
}

export function loadHiddenTypes(pageKey: string): Set<string> {
  try {
    const raw = localStorage.getItem(storageKey(pageKey));
    const arr = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(arr) ? arr : []);
  } catch {
    return new Set();
  }
}

export function saveHiddenTypes(pageKey: string, hidden: Set<string>): void {
  try {
    localStorage.setItem(storageKey(pageKey), JSON.stringify([...hidden]));
  } catch {
    /* storage unavailable — filters just won't persist */
  }
}

// ── Team-calendar scope ─────────────────────────────────────────────────────
//
// ⚠️ DEFAULTS TO 'direct' — immediate reports only. 'team' walks the whole
// reporting subtree, which near the top of an org chart is the entire company
// (Fern's Group CEO: 12 direct reports, 84 in his subtree, 85 in the tenant).
// The remembered choice is a PREFERENCE, never a permission: the server
// re-decides what the caller may see on every request, so a stale or
// hand-edited value can widen nothing.
const SCOPE_KEY = 'amashr_calendar_scope';

export type TeamCalendarScope = 'direct' | 'team';

export function loadTeamScope(): TeamCalendarScope {
  try {
    const raw = localStorage.getItem(`${SCOPE_KEY}_${storageKey('scope')}`);
    return raw === 'team' ? 'team' : 'direct';
  } catch {
    return 'direct';
  }
}

export function saveTeamScope(scope: TeamCalendarScope): void {
  try {
    localStorage.setItem(`${SCOPE_KEY}_${storageKey('scope')}`, scope);
  } catch {
    /* private window / blocked storage — the default is correct anyway */
  }
}
